<template>
	<div>
		<audio :src='src' id="audioText" autoplay="autoplay"></audio>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				src: '',
				voiceText: '',
			}
		},
		mounted() {},
		methods: {
			voicePlay(txt) {
				this.voiceText = txt;
				if (!this.voiceText) {
					return false;
				}
				this.$axios.get(`/common/tts?text=${this.voiceText}`).then(data => {
					if (data.success && data.data) {
						this.src = data.data;
						this.voiceText = '';
					} else {
						this.$message.error(data.msg);
					}
				})
				let audio = document.querySelector("#audioText");
				audio.load();
				let playPromise = audio.play() ;
				if (playPromise !== undefined) {
					playPromise.then(() => {
						audio.play()
					}).catch(() => {})
				}
				this.src = ""

			},
		},
	}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/common/voice.text.vue